<template>

<div v-if="dissave"  style="position:absolute; top: 300px;   width: 100%; z-index:100;  ">
  <Circle4 size="120px" class="mx-auto"></Circle4>
</div>




  <div>
    <!--<form method="post">-->
    <h4 class="text-primary font-weight-bolder">Ҷустуҷӯ</h4>
    <hr />
    <div class="col-4">
      <div class="mb-2">
        <label class="form-label" for="name">Насаб</label>
        <input class="form-control" name="surname" v-model="surname" />
      </div>      
      <div class="mb-2">
        <label class="form-label" for="name">Ном</label>
        <input class="form-control" name="name" v-model="name" />
      </div>



      <Button class="btn btn-primary" @click="find()" :disabled="dissave" > Ҷустуҷӯ</Button>
    </div>

    <!--</form>-->

    <table class="table table-striped">
      <thead>
        <tr>
          <th>#</th>
          <th>Ном</th>
          <th>Насаб</th>
          <th>Ҷинс</th>
          <th>Соли таваллуд</th>
          <th>Суроға</th>
          <th>Суратҳисоб</th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="list.length==0 && start==1">
          <td colspan="8" style="color:red">
                    Маълумот ёфт нашуд
          </td>
        </tr>
        <tr v-for="l in list" :key="l">
          <td>
            {{ l.Mid }}
          </td>
          <td>
            {{ l.Name }}
          </td>
          <td>
            {{ l.Surname }}
          </td>
          <td>
            {{ l.Sex }}
          </td>

          <td>
            {{ l.Birthday }}
          </td>

          <td>
            {{ l.Address }}
          </td>
          <td>
            {{ l.Account }}
          </td>

          <td>
            <button @click="Edit(l.Hid)" class="btn btn-primary">Гузариш</button>
            &nbsp;
            <button @click="Spravka(l.Hid, l.Mid)" class="btn btn-info" >
              Чопкунӣ
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>


  <mod v-if="isShowRep" @close="closemod" @scroll="scrollmod" >
  
    <template v-slot:body>
      <member   :id="idrep" ref="repComponent" @close="closemod"></member>
      </template>
  
  </mod>


    <mod v-if="isShowPrint" @close="closemod" @scroll="scrollmod" >
  
    <template v-slot:body>
      <spravka   :id="idrep" ref="repComponent" @close="closemod"></spravka>
      </template>
  
  </mod>


</template>



<script>

 import mod from './ModalForm.vue'
import member from './Members2.vue'
import spravka from './Spravka.vue'

export default {
  
  components:{mod, member,spravka},
  data() {
    return {
      isShowRep:false,
      isShowPrint:false,
      idrep:0,
      list: "",
      start:0,
      name: "",
      surname: "",
      dissave:false
    };
  },

  methods: {
    async find() {
      this.dissave=true;

      console.log("start3");
      try {
        await this.$api("/api/find/"+this.$store.state.terid+'/' + this.name + " /" + this.surname + " /")
        //  .then((res) => res.json())
          .then((data) => (this.list = data))
          .catch((error) => {
            console.error("There was an error!", error);
          });

        console.log("stop3");
      } catch (ex) {
        console.log(ex);
      } finally {
        console.log("finish");
      }
      this.start=1;
      this.dissave=false;
    },
    find2() {
      this.dissave=true;
      console.log("start3");

      const requestOptions = {
        method: "Get",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: this.name, surname: this.surname }),
      };
      fetch(this.$store.state.server+"/api/find", requestOptions)
        .then((res) => res.json())
        .then((data) => (this.list = data))
        .catch((error) => {
          console.error("There was an error!", error);
        });

      console.log("stop3");
      this.dissave=false;
    },
    closemod(){
  this.isShowPrint=false;
  this.isShowRep=false;
},

scrollmod(){
  this.$refs.repComponent.onScroll()
  //  console.log('modal scrolled')

},

    async Go(f) {
      console.log("go to id=", f);

      console.log("start2");
      await this.$api("/api/data/2/0/" + f)
      //  .then((res) => res.json())
        .then((data) => (this.$store.state.household = data))
        .catch((error) => {
          console.error("There was an error!", error);
        });

      this.$router.push("/Members");
    },
    async Edit(id) {
      console.log("edit id=", id);

      await this.$api("/api/data/2/0/" + id)
       // .then((res) => res.json())
        .then((data) => (this.$store.state.household = data))
        .catch((error) => {
          console.error("There was an error!", error);
          return;
        });

 this.idrep=id;

 this.isShowRep=true;

    },

    async Spravka(hid,mid) {
      console.log(hid,mid);

        this.$store.state.mid = mid;
        /*
      await fetch("/api/data/2/0/" + hid)
        .then((res) => res.json())
        .then((data) => (this.$store.state.household = data))
        .catch((error) => {
          console.error("There was an error!", error);
        });
*/
 this.isShowPrint=true;
      // this.$router.push("./spravka");
    },
  },
};
</script>
